import AutoForm from '@/components/atoms/AutoForm'
import CheckBox from '@/components/atoms/inputs/CheckBox'
import ColorPicker from '@/components/atoms/inputs/ColorPicker'
import ContactsPopover from '@/components/atoms/ContactsPopover'
import CurrencyInput from '@/components/atoms/inputs/CurrencyInput'
import DashText from '@/components/atoms/DashText'
import DataTable from '@/components/atoms/tables/DataTable'
import GoodTable from '@/components/atoms/tables/GoodTable'
import DateInput from '@/components/atoms/inputs/DateInput'
import DateTimeInput from '@/components/atoms/inputs/DateTimeInput'
import EditPane from '@/components/atoms/EditPane'
import FilesPanel from '@/components/atoms/files/FilesPanel'
import FileUpload from '@/components/atoms/files/FileUpload'
import FloatInput from '@/components/atoms/inputs/FloatInput'
import HtmlInput from '@/components/atoms/inputs/HtmlInput'
import IntegerInput from '@/components/atoms/inputs/IntegerInput'
import NumberInput from '@/components/atoms/inputs/NumberInput'
import Popup from '@/components/atoms/Popup'
import OrgBadge from '@/components/atoms/OrgBadge'

import SelectActionStatus from '@/components/atoms/selects/SelectActionStatus'
import SelectFrequency from '@/components/atoms/selects/SelectFrequency'
import SelectSpectrum from '@/components/atoms/selects/SelectSpectrum'
import SelectServiceType from '@/components/atoms/selects/SelectServiceType'
import SelectInput from '@/components/atoms/selects/SelectInput'
import SelectSite from '@/components/atoms/selects/SelectSite'
import SelectOrganisation from '@/components/atoms/selects/SelectOrganisation'
import SelectMonth from '@/components/atoms/selects/SelectMonth'
import SelectPriority from '@/components/atoms/selects/SelectPriority'
import SelectUsers from '@/components/atoms/selects/SelectUsers'
import SelectYear from '@/components/atoms/selects/SelectYear'

import SwitchInput from '@/components/atoms/inputs/SwitchInput'

import TagInput from '@/components/atoms/inputs/TagInput'
import TextArea from '@/components/atoms/inputs/TextArea'
import TextInput from '@/components/atoms/inputs/TextInput'
import TimeInput from '@/components/atoms/inputs/TimeInput'

const components = [
  AutoForm,
  CheckBox,
  ColorPicker,
  ContactsPopover,
  CurrencyInput,
  DashText,
  DataTable,
  GoodTable,
  DateInput,
  DateTimeInput,
  EditPane,
  FilesPanel,
  FileUpload,
  FloatInput,
  HtmlInput,
  NumberInput,
  IntegerInput,
  Popup,
  OrgBadge,
  SelectActionStatus,
  SelectFrequency,
  SelectSpectrum,
  SelectServiceType,
  SelectInput,
  SelectSite,
  SelectPriority,
  SelectOrganisation,
  SelectMonth,
  SelectYear,
  SelectUsers,
  SwitchInput,
  TagInput,
  TextArea,
  TextInput,
  TimeInput
]

const install = function (Vue, opts = {}) {

  components.forEach(component => {
    Vue.component(component.name, component)
  })

}

/* istanbul ignore if */
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
  AutoForm,
  CheckBox,
  ColorPicker,
  ContactsPopover,
  CurrencyInput,
  DashText,
  DataTable,
  GoodTable,
  DateInput,
  DateTimeInput,
  EditPane,
  FilesPanel,
  FileUpload,
  FloatInput,
  HtmlInput,
  IntegerInput,
  NumberInput,
  Popup,
  OrgBadge,
  SelectActionStatus,
  SelectFrequency,
  SelectSpectrum,
  SelectServiceType,
  SelectInput,
  SelectSite,
  SelectPriority,
  SelectOrganisation,
  SelectMonth,
  SelectYear,
  SelectUsers,
  SwitchInput,
  TagInput,
  TextArea,
  TextInput,
  TimeInput
}
